import { SET_PROGRESS, SET_EXTRACTION_PROGRESS, CLEAR_EXTRACTION_PROGRESS } from "./types";

export const setDocUploadProgress = (value) => {
  return {
    type: SET_PROGRESS,
    payload: value,
  };
};

/**
 * Un evento di avanzamento dell'estrazione, cosi' com'e' arrivato da
 * `processFile` (worker, condotto largo): `{ fileName, phase, progress,
 * message }`. La card lo mostra al posto della scritta fissa "Estrazione del
 * testo in corso...": e' l'unica barra che non mente, perche' il numero viene
 * da chi sta davvero leggendo il file.
 */
export const setExtractionProgress = ({ fileName, phase, progress, message }) => ({
  type: SET_EXTRACTION_PROGRESS,
  payload: {
    fileName: fileName || '',
    phase: phase || null,
    progress: Number.isFinite(progress) ? Math.max(0, Math.min(100, Math.round(progress))) : null,
    message: message || '',
  },
});

export const clearExtractionProgress = () => ({ type: CLEAR_EXTRACTION_PROGRESS });
